import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button, tokens } from '@treams/treams-ui';

import ProductLayout from './ProductLayout';

const Contact = styled(Flex)`
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 50%;
	align-items: center;

	img {
		width: 64px;
		height: 64px;
		border-radius: 50%;
		flex-grow: 0;
		flex-shrink: 0;
	}
`;

const Info = styled(Box)`
	flex-grow: 1;
	flex-shrink: 1;
`;

const Name = styled(Box)`
	font-weight: bold;
`;

const Position = styled(Box)`
	color: ${tokens.text.secondary};
`;

export default function BillingSuccess() {
	const { t } = useTranslation();

	return (
		<ProductLayout
			title={t('billing.success.title')}
			cta={<Button type="primary" title={t('billing.success.cta')} link="/" />}
		>
			<p>{t('billing.success.subtitle')}</p>
			<p>{t('billing.success.description')}</p>

			<Flex>
				<Contact mr={2}>
					<img src="/images/team/lucienne.jpg" alt="Luciënne van de Kar" />
					<Info ml={2}>
						<Name mb={1}>Luciënne van de Kar</Name>
						<Position>Business Development Manager</Position>
					</Info>
				</Contact>
				<Contact ml={2}>
					<img src="/images/team/yvette.png" alt="Yvette Klessens" />
					<Info ml={2}>
						<Name mb={1}>Yvette Klessens</Name>
						<Position>Business Development Manager</Position>
					</Info>
				</Contact>
			</Flex>
		</ProductLayout>
	);
}
